import {apiClient, FetcherSettings} from './apiClient';
import {dynamicRoute} from './utils';
import {GuestGroup} from '../utils';
import {GuestGroupPayload} from '../services';

class GuestGroupApi {
  ENDPOINTS = {
    guestGroup: dynamicRoute({
      regular: (id = '') => `api/v4/guestapp/guest-group/${id}/`,
      sdk: (id = '') => `sdk/api/v1/guestapp/guest-group/${id}/`,
    }),
  };

  async getGuestGroup(id: string, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.get<GuestGroup>(this.ENDPOINTS.guestGroup(id), {
      requireEncryption: true,
      ...fetcherSettings,
    });
    return response.body;
  }

  async patchGuestGroup(
    id: string,
    payload: GuestGroupPayload,
    fetcherSettings?: FetcherSettings,
  ) {
    const response = await apiClient.patch<GuestGroup>(this.ENDPOINTS.guestGroup(id), {
      json: payload,
      ...fetcherSettings,
    });
    return response.body;
  }
}

export {GuestGroupApi};
